import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b4ec722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-your-event--section ticket-your-event--section--integrations" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Integrate with ease", -1))
const _hoisted_3 = { class: "list--container" }
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.integrations, (integration) => {
            return (_openBlock(), _createElementBlock("li", { key: integration }, [
              _createElementVNode("img", {
                src: 'images/b2b/integration/' + integration + '.svg',
                alt: integration,
                title: integration
              }, null, 8, _hoisted_4),
              _createElementVNode("span", _hoisted_5, _toDisplayString(integration), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}